<template>
  <div class="ai-picture">
    <div class="pic-time-list">
      <el-divider v-if="isHistory">
        <div class="time">{{ howLong(aiTask.modifyDate) }}</div>
      </el-divider>
      <div v-if="!isHistory" class="set f-b-c">
        <div v-if="aiTask.parameters" class="name ellipsis">{{ aiTask.parameters.prompt }}</div>
        <div v-if="aiTask.status === 'In Complete'" class="f--c" style="flex-shrink: 0;">
          <div class="set-icon pointer" @click="handleCustomize()">
            <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_453_15473)"><path id="Vector" d="M6.3345 2.66699L9.3345 5.33366L12.6786 3.37026L11.0012 7.00032L14.0012 9.66699L10.0012 9.33366L8.50117 12.667L7.66784 9.00032L3.66797 8.66699L7.17057 6.55032L6.3345 2.66699Z" stroke="#9AC331" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_2" d="M2.66797 14.0068L7.66797 9" stroke="#9AC331" stroke-width="1.33333" stroke-linecap="round"/></g><defs><clipPath id="clip0_453_15473"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>
            <div>Customize</div>
          </div>
          <div class="set-icon pointer" @click="handleDownload">
            <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_453_15493)"><g><path id="Vector" d="M2 8.00277V14H14V8" stroke="#9AC331" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_2" d="M11 7.66699L8 10.667L5 7.66699" stroke="#9AC331" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_3" d="M7.99609 2V10.6667" stroke="#9AC331" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></g></g><defs><clipPath id="clip0_453_15493"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>
            <div>Download</div>
          </div>
          <el-popconfirm icon="el-icon-warning" title="Are you sure to delete this image?" confirm-button-text="Yes" cancel-button-text="No" @confirm="handleDelete('all')">
            <div slot="reference" class="set-icon pointer">
              <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_453_15485)"><path id="Vector" d="M3 3.33301V14.6663H13V3.33301H3Z" stroke="#9AC331" stroke-width="1.33333" stroke-linejoin="round"/><path id="Vector_2" d="M6.66797 6.66699V11.0003" stroke="#9AC331" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_3" d="M9.33203 6.66699V11.0003" stroke="#9AC331" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_4" d="M1.33203 3.33301H14.6654" stroke="#9AC331" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_5" d="M5.33203 3.33301L6.42836 1.33301H9.59106L10.6654 3.33301H5.33203Z" stroke="#9AC331" stroke-width="1.33333" stroke-linejoin="round"/></g><defs><clipPath id="clip0_453_15485"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>
              <div>Delete</div>
            </div>
          </el-popconfirm>
        </div>
        <div v-else class="f--c" style="flex-shrink: 0;">
          <div v-if="aiTask.status === 'In Waiting'" class="gray">
            {{ `${aiTask.queue} More ahead, expected to wait for ${aiTask.estimateTime||0} s`}}
          </div>
          <div v-if="aiTask.status === 'In Progress'" class="progress f--c">
            <el-progress :percentage="aiTask.progress"></el-progress>
          </div>
          <!-- <div>
            Estimated waiting time: {{ aiTask.estimateTime }}
          </div> -->
          <el-popover
            v-if="aiTask.status !== 'IN INTERRUPT'"
            placement="top"
            width="310"
            v-model="popoverShow">
            <div style="font-size:13px;color:#303133;margin-bottom:10px;">Confirm stop generation?</div>
            <div style="font-size:12px;color:#606266;margin-bottom:14px;">Are you sure you want to cancel image generation?</div>
            <div style="text-align: right; margin: 0">
              <el-button size="small" @click="popoverShow = false">Cancel</el-button>
              <el-button type="danger" size="small" @click="aiCustomImgStop">Confirm</el-button>
            </div>
            <div slot="reference" class="set-icon red pointer">
              <i class="el-icon-circle-close" style="font-size:16px"></i>
              <div v-if="aiTask.status === 'In Waiting'" style="margin-left:4px">Cancel</div>
            </div>
          </el-popover>
        </div>
      </div>
      <div class="picture-list f--c">
        <div v-for="(item, i) in aiTask.images" :key="item.oosImgName" class="picture-item" :style="{ height: isHistory ? `calc((100vw - 80px) / 4)` : `calc((100vw - 440px) / 4)`, minHeight: isHistory ? '280px' : '200px' }">
          <ai-picture :status="aiTask.status" :aiPicture="item" :index="i" @handleDelete="handleDelete" @handleCustomize="handleCustomize" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AiPicture from './AiPicture.vue'
import API from '@/api'
import _ from 'lodash'
export default {
  components: { AiPicture },
  props: {
    isHistory: {
      type: Boolean,
      default: false
    },
    aiTask: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: true,
      popoverShow: false
    }
  },
  created() {},
  methods: {
    handleCustomize(img) {
      let imageList = img ? [img] : this.aiTask.images.map(item => item.oosUrl)
      this.$store.commit('commodity/set', {
        customProduct: {
          path: 'ai',
          imageList
        }
      })
      // this.$router.push({
      //   path: '/commodity/customProduct/add',
      //   query: { from: 'ai' }
      // })
      let routeUrl = this.$router.resolve({
        path: '/commodity/customProduct/add',
        query: { from: 'ai' }
      })
      window.open(routeUrl.href, '_blank')
    },
    handleDownload() {
      // this.aiTask.images.forEach(item => {
      //   window.open(item.oosUrl)
      // })
      var count = 0
      for (var i = 0; i < this.aiTask.images.length; i++) {
        var hiddenIFrameID = 'hiddenDownloader' + count++
        var iframe = document.createElement('iframe')
        iframe.id = hiddenIFrameID
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
        iframe.src = this.aiTask.images[i].oosUrl // 直接下载，不会弹出新的页面
      }
    },
    handleDelete(type) {
      let aiTask = _.cloneDeep(this.aiTask)
      let param = { taskId: this.aiTask.taskId, images: [] }
      if (type !== 'all') {
        aiTask.images = aiTask.images.filter((t, i) => i !== type)
        param.images = aiTask.images
        if (!param.images.length) param.type = 'all'
      } else param.type = type
      this.$emit('handleDelete', param)
    },
    howLong(old) {
      let now = new Date().getTime()
      let time = (now - old) / 1000 / 60
      if (time <= 60) {
        return `${Math.floor(time)} minute${Math.floor(time) === 1 ? '' : 's'} ago`
      } else if (time / 60 <= 24) {
        return `${Math.floor(time / 60)} hour${Math.floor(time / 60) === 1 ? '' : 's'} ago`
      } else {
        return `${Math.floor(time / 60 / 24)} day${Math.floor(time / 60 / 24) === 1 ? '' : 's'} ago`
      }
    },
    aiCustomImgStop() {
      API.aiCustomImgStop({ taskId: this.aiTask.taskId }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$emit('handleCancel', this.aiTask.taskId)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ai-picture {
  width: 100%;
  padding: 20px 22px;
  box-sizing: border-box;

  .pic-time-list {

    .time {
      color: #C0C4CC;
      font-size: 12px;
      font-weight: 400;
    }

    .set {
      font-size: 14px;
      margin-bottom: 16px;

      .progress {
        padding-left: 10px;
        color: #909399;
        width: calc((100vw - 404px) / 3);
        min-width: 260px;
        max-width: 470px;

        /deep/ .el-progress {
          flex: 1;
          position: relative;
          margin-left:8px;
          .el-progress-bar {
            padding-right: 40px;
          }
          .el-progress__text {
            position: absolute;
            right: 0;
          }
        }
      }

      .name {
        color: #303133;
      }

      .set-icon {
        display: flex;
        align-items: center;
        margin-left: 16px;
        color: #9AC331;

        svg {
          margin-right: 4px;
        }
      }
      .red {
        color: #F36D6F;
      }
    }

    .picture-list {
      width: 100%;
      box-sizing: border-box;

      .picture-item {
        width: calc((100% - 36px) / 4);
        height: calc((100vw - 440px) / 4);
        min-height: 200px;
        margin-right: 12px;
        border-radius: 4px;
        overflow: hidden;
        &:last-child {
          margin-right: 0;
        }
      }
    }

    .gray {
      color: #909399;
      font-size: 12px;
    }
  }
}
</style>
